__webpack_require__.p = "https://cp-landing-test.wukongacademy.com/_next/";